import * as TK from 'components/PDP/Details/components/PasControl/components/SuggestedArrangement/translations/locale.constants';

export const suggestedProductsCommonLocale = {
  [TK.TITLE]: 'Suggested products for you',
  [TK.VIEW_ALL]: 'View All Products',
  [TK.NO_SUGGESTIONS]:
    'Sorry, we can’t suggest you any products at this moment.',
};
